// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__m8Vdf","body":"Layout_body__AOzHb"};